import { baseBUCGet } from '../base/baseBUC';

const str = '';
const decimal = 0.00;
const dateTimeStr = new Date()?.toISOString();

export const bankAccountMovementModelGet = ({
    buildingId = '',
    bankId = '',
    bankAccountId = '',
    type = '',
    subType = '',
    userId = '',
}) => {
    return {
        bankId: bankId,
        bankAccountId: bankAccountId,
        amount: decimal,
        date: dateTimeStr,
        reference: str,
        remark: str,
        subType: subType,
        type: type,
        ...baseBUCGet({ buildingId: buildingId, userId: userId, }),
    }
};